import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { stateName } from './constants';
export const initialState = {
  countryBounds: undefined,
  nearbyDropOffPoints: undefined,
  selectedDropOffPoint: undefined,
  suggestedDropOffPointCode: undefined,
  dropOffPointCarrier: undefined,
  dropOffPointSource: undefined,
  ui: {
    error: null,
    uiState: UiState.Idle
  }
};

const fetchCountryBoundsSuccess = (draft, action) => {
  const {
    countryBounds
  } = action.payload;
  draft.countryBounds = countryBounds;
};

const fetchNearbyDropOffPointsRequest = draft => {
  draft.ui.uiState = UiState.Pending;
  draft.selectedDropOffPoint = null;
};

const fetchNearbyDropOffPointFailure = draft => {
  draft.nearbyDropOffPoints = [];
  draft.ui.uiState = UiState.Failure;
};

const fetchNearbyDropOffPointSuccess = (draft, action) => {
  draft.nearbyDropOffPoints = action.payload.dropOffPoints;
  draft.suggestedDropOffPointCode = action.payload.suggestedDropOffPointCode;
  draft.dropOffPointCarrier = action.payload.dropOffPointCarrier;
  draft.dropOffPointSource = action.payload.dropOffPointSource;
  draft.ui.uiState = UiState.Success;
};

const setSelectedDropOffPoint = (draft, action) => {
  draft.selectedDropOffPoint = action.payload.selectedDropOffPoint;
};

const dropOffPointMapSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    fetchCountryBoundsSuccess,
    fetchNearbyDropOffPointsRequest,
    fetchNearbyDropOffPointFailure,
    fetchNearbyDropOffPointSuccess,
    setSelectedDropOffPoint
  }
});
export const {
  actions
} = dropOffPointMapSlice;
export const plug = {
  [stateName]: dropOffPointMapSlice.reducer
};
export default dropOffPointMapSlice.reducer;